export class ChangeJsonConfiguration {
   public static readonly type = '[DynamicActionsBrickSettings] Change JSON configuration';

   constructor(public brickInstanceId: string, public jsonConfiguration: string) {}
}
